import SimpleLightbox from 'simple-lightbox';

var lightbox = new SimpleLightbox({
    elements: document.querySelectorAll('.slider-image-lightbox')
});


// WEBPACK FOOTER //
// ./assets/js/src/modules/gallery.js